<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    @if(approvedAmount && !showVKYC){
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h4 class="heading mb-1">Congratulations! 🎉</h4>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">

                <div class="row justify-content-center">
                    <div class="col-11 text-center">

                        <p class="mt-3 mx-1">
                            Your application has been approved. You are eligible for the amount of:
                        </p>

                        <h2 class="fw-bold text-success mb-3">
                            {{ this.approvedAmount | currency: 'INR':'symbol':'1.0-0' }}
                        </h2>

                        <p class="content mb-4">
                            You can proceed to complete the process and access your funds.
                        </p>

                        <button type="button" class="btn btn-warning px-5" (click)="proceedProcess()">
                            Proceed
                        </button>

                    </div>
                </div>
            </div>
        </div>
    </div>

    }
    @else{
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h4 class="heading">Complete Your Video KYC in a Minute​</h4>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">

                <div class="row justify-content-center">
                    <div class="col-11 text-center">

                        <ol class="text-start mt-3 mb-4 content">
                            <li>Keep your <span>Pan Card</span> ready.</li>
                            <li>Click <span>Video KYC</span> to begin.</li>
                            <li>Allow <span>camera and microphone</span> access when prompted.</li>
                            <li>Hold your <span>PAN Card</span> clearly in front of the camera.</li>
                            <li>Read out your <span>PAN number</span> when asked.</li>
                            <li>Follow the simple steps shown on-screen.</li>
                            <li>You’ll be brought back here automatically once you're done!</li>
                        </ol>

                        <button type="button" class="btn btn-warning px-5" (click)="startVideoKyc()">
                            Start Video KYC
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>